module.exports = __webpack_public_path__ + "img/mag.929e6345.png";